import styled from 'styled-components';
import {
  ScStepsByGroup,
  ScStepsByGroupCard,
} from '@/modules/restrictions/components/StepsByGroup/styled';
import { device } from '@/styles/helpers';

export const ScHowTo = styled.div`
  position: relative;
  z-index: 1;

  ${ScStepsByGroup} {
    padding: 24px 0;

    margin-top: 45px;

      @media (${device.mobile}) {
        margin-top: 24px;
      }
    

    .cards {
      align-items: stretch;
    }
  }

  ${ScStepsByGroupCard} {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .image {
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .content {
    max-width: 1088px;
    margin-inline: auto;
    padding: 0 16px;
  }

  .titleAccent {
    position: relative;
    width: 100%;
    height: 29px;
    margin-bottom: 8px;

    img {
      object-fit: contain;
    }
  }
`;
